import { render, staticRenderFns } from "./rjBasicInformation.vue?vue&type=template&id=23b8d136&scoped=true"
import script from "./rjBasicInformation.vue?vue&type=script&lang=js"
export * from "./rjBasicInformation.vue?vue&type=script&lang=js"
import style0 from "./rjBasicInformation.vue?vue&type=style&index=0&id=23b8d136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b8d136",
  null
  
)

export default component.exports